module.exports = __webpack_public_path__ + "static/media/girl-2.30b5ea95.svg";